import { Component, Input } from '@angular/core';
import { DataSetSettingEnum } from '../../../shared/enums/data-set-setting.enum';


@Component({
  selector: 'app-print-combination-building-details',
  templateUrl: './print-combination-building-details.component.html',
    styleUrl: './print-combination-building-details.component.scss',
    standalone: false
})
export class PrintCombinationBuildingDetailsComponent {
    @Input({ required: true }) details!: CombinationBuildingPrintDto;
    @Input({ required: true }) isCombinationBuildingSelected!: boolean;
    @Input() selectedDataSet: number;


    public get totalBvo(): number {
        return this.details.functions.reduce((total, item) => total + item.bvoTotal, 0);
    }

    public get totalGo(): number {
        return this.details.functions.reduce((total, item) => total + item.goTotal, 0);
    }

    get isA2Visible(): boolean {
        return this.selectedDataSet === DataSetSettingEnum.A2 || this.selectedDataSet === DataSetSettingEnum.A1A2;
    }

    public get averageMpgRequirement(): number {
        if (!this.details.functions.length) {
            return 0;
        }

        return this.details.functions.reduce((total, item) => total + item.mpgRequirement, 0)
            / this.details.functions.length;
    }

    /**
      * Returns the effective MPG limit value to display:
      * - Combination building: (mpgLimitEasedA2 + mpgLimitA2) / goTotal
      * - Regular building: mpgLimitEasedA2 if present, otherwise mpgLimitA2
      */
    getMpgLimitDisplayValue(): number | null {
        const mpgLimitA2 = this.details?.facadeSurface.mpgLimitA2;
        const mpgLimitEasedA2 = this.details?.facadeSurface.mpgLimitEasedA2;
        const goTotal = this.totalGo;

        if (this.isCombinationBuildingSelected) {
            if (mpgLimitEasedA2 != null  &&  mpgLimitA2 != null  &&  goTotal != null && goTotal !== 0) {
                return (Number(mpgLimitEasedA2) + Number(mpgLimitA2)) / goTotal;
            }
            return null;
        }

        if (mpgLimitEasedA2 != null) {
            return Number(mpgLimitEasedA2);
        }
        if (mpgLimitA2 != null) {
            return Number(mpgLimitA2);
        }
        return null;
    }

}

export interface CombinationBuildingPrintDto {
    functions: CombinationBuildingFunctionDto[];
    sharedSpaces: CombinationBuildingSharedSpaceDto[];
    facadeSurface: {
        surface: number;
        compactness: number;
        mpgAmbition: number;
        mpgLimitA2: number;
        mpgLimitEasedA2: number;
        correctionFactor: number;
    };
}

export interface CombinationBuildingFunctionDto {
    referenceNumber?: number;
    name: string;
    units: number;
    bvo: number;
    go: number;
    bvoTotal: number;
    goTotal: number;
    mpgRequirement: number;
}

export interface CombinationBuildingSharedSpaceDto {
    bvo: number;
    gbo: number;
    allocation: string;
    functionReferenceNumber?: number;
}